<div class="waitingWrap mx-auto max-w-[1440px] w-full  md:px-0">
    <div class="mx-auto mainWrap w-full flex bg-[#202425] h-[88px] lg:min-h-[188px] max-w-[1760px]
     flex-row items-center justify-between md:ps-20 ps-3  mt-4 md:mt-14 mb-1 sm:gap-3 md:gap-14">
        <div class="contentWrap">
            <h1> Questions about Cash on Delivery? <br> Contact us for assistance today! </h1>
        </div>
        <div class="arrow h-full " (click)="link()">
            <!-- <button routerLink="/signup"> -->
                <svg class="w-[38px] h-[27px] md:w-[59px] lg:h-[94px]"  viewBox="0 0 59 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.289062 82.8767L36.1657 47L0.289062 11.045L11.3341 0L58.3341 47L11.3341 94L0.289062 82.8767Z" fill="#00DF9A"/>
                </svg>                
            <!-- </button> -->
            </div>
    </div>
</div>